//@flow
import * as React from 'react';
import { useStore } from 'effector-react';
import { typeErrors, typeHint } from './domain';
import { typeHoverToggle } from '../settings/domain';
import type { FlowMessage, FlowInfoTree } from './index.h';
import { styled } from 'linaria/react';
const lineHeight = 1.5;
const lines = 3;
const TypeHint =
/*#__PURE__*/
styled("pre")({
  name: "TypeHint",
  class: "t1ofkdyg"
});
const TypeErrors =
/*#__PURE__*/
styled("pre")({
  name: "TypeErrors",
  class: "t8hyvsr"
});
const Scroll =
/*#__PURE__*/
styled("div")({
  name: "Scroll",
  class: "s1swsn7u"
});
export const TypeHintView = () => {
  const type = useStore(typeHint);
  const enabled = useStore(typeHoverToggle);
  return enabled ? null : <TypeHint>{type}</TypeHint>;
};

const ErrorMessage = ({
  type,
  loc,
  context,
  descr
}: FlowMessage) => {
  if (loc && loc.source != null && context != null) {
    const basename = loc.source.replace(/.*\//, '');
    const filename = basename !== 'repl.js' ? `${loc.source}:` : '';
    const prefix = `${filename}${loc.start.line}: `;
    const before = context.slice(0, loc.start.column - 1);
    const highlight = loc.start.line === loc.end.line ? context.slice(loc.start.column - 1, loc.end.column) : context.slice(loc.start.column - 1);
    const after = loc.start.line === loc.end.line ? context.slice(loc.end.column) : '';
    const offset = loc.start.column + prefix.length - 1;
    const arrow = `${(prefix + before).replace(/[^ ]/g, ' ')}^ `;
    return <>
        <div>
          {prefix + before}
          <strong className="msgHighlight">{highlight}</strong>
          {after}
        </div>
        {arrow}
        <span className="msgType">{descr}</span>
      </>;
  } else if (type === 'Comment') {
    return `. ${descr}\n`;
  } else {
    return `${descr}\n`;
  }
};

const Extra = ({
  message,
  children
}: FlowInfoTree) => {
  return <ul>
      {message && <li>
          {message.map((message, key) => <ErrorMessage key={key} {...message} />)}
        </li>}
      {children && <li>
          {children.map((extra, key) => <Extra key={key} {...extra} />)}
        </li>}
    </ul>;
};

export const TypeErrorsView = () => {
  const errors = useStore(typeErrors);
  return <TypeErrors>
      <Scroll>
        <ul>
          {errors.map((error, key) => {
          // TODO: hide libdefs until errors are fixed
          if (process.env.NODE_ENV === 'production' && error.message[0].loc?.type === 'LibFile') return null;
          return <li key={key}>
                {error.message.map((message, key) => <ErrorMessage key={key} {...message} />)}
                {error.extra && error.extra.map((extra, key) => <Extra key={key} {...extra} />)}
              </li>;
        })}
        </ul>
      </Scroll>
    </TypeErrors>;
};